/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConteneurDto } from '../models/conteneur-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DemandeTransportDto } from '../models/demande-transport-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des conteneurs
 */
@Injectable({
  providedIn: 'root',
})
export class ConteneursService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation conteneurGetList
   */
  static readonly ConteneurGetListPath = '/api/conteneurs/list';

  /**
   * Renvoie la liste des conteneurs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ConteneurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConteneurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGetList(params?: {
  }): Observable<Array<ConteneurDto>> {

    return this.conteneurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ConteneurDto>>) => r.body as Array<ConteneurDto>)
    );
  }

  /**
   * Path part for operation conteneurLoadList
   */
  static readonly ConteneurLoadListPath = '/api/conteneurs/load-list';

  /**
   * Renvoie la liste des conteneurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.conteneurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation conteneurGet
   */
  static readonly ConteneurGetPath = '/api/conteneurs/{id}';

  /**
   * Renvoie le conteneur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGet$Response(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;
  }): Observable<StrictHttpResponse<ConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurDto>;
      })
    );
  }

  /**
   * Renvoie le conteneur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGet(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;
  }): Observable<ConteneurDto> {

    return this.conteneurGet$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurDto>) => r.body as ConteneurDto)
    );
  }

  /**
   * Path part for operation conteneurPut
   */
  static readonly ConteneurPutPath = '/api/conteneurs/{id}';

  /**
   * Modifie le conteneur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurPut$Response(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;

    /**
     * Valeurs du conteneur
     */
    body: ConteneurDto
  }): Observable<StrictHttpResponse<ConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurDto>;
      })
    );
  }

  /**
   * Modifie le conteneur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurPut(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;

    /**
     * Valeurs du conteneur
     */
    body: ConteneurDto
  }): Observable<ConteneurDto> {

    return this.conteneurPut$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurDto>) => r.body as ConteneurDto)
    );
  }

  /**
   * Path part for operation conteneurDelete
   */
  static readonly ConteneurDeletePath = '/api/conteneurs/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.conteneurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation conteneurDesactivate
   */
  static readonly ConteneurDesactivatePath = '/api/conteneurs/{id}/desactivate';

  /**
   * Désactive le conteneur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurDesactivate$Response(params: {

    /**
     * Identifiant du conteneur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ConteneurDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le conteneur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurDesactivate(params: {

    /**
     * Identifiant du conteneur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ConteneurDto
  }): Observable<number> {

    return this.conteneurDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation conteneurGetByReference
   */
  static readonly ConteneurGetByReferencePath = '/api/conteneurs/reference/{reference}';

  /**
   * Renvoie le conteneur recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<ConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurDto>;
      })
    );
  }

  /**
   * Renvoie le conteneur recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<ConteneurDto> {

    return this.conteneurGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurDto>) => r.body as ConteneurDto)
    );
  }

  /**
   * Path part for operation conteneurGetDemande
   */
  static readonly ConteneurGetDemandePath = '/api/conteneurs/dernieresdemandes/{conteneurId}';

  /**
   * Renvoie la dernière demande de transport du conteneur.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurGetDemande()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGetDemande$Response(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;
  }): Observable<StrictHttpResponse<DemandeTransportDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurGetDemandePath, 'get');
    if (params) {
      rb.path('conteneurId', params.conteneurId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeTransportDto>;
      })
    );
  }

  /**
   * Renvoie la dernière demande de transport du conteneur.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurGetDemande$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurGetDemande(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;
  }): Observable<DemandeTransportDto> {

    return this.conteneurGetDemande$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeTransportDto>) => r.body as DemandeTransportDto)
    );
  }

  /**
   * Path part for operation conteneurLoadListDemandes
   */
  static readonly ConteneurLoadListDemandesPath = '/api/conteneurs/dernieresdemandes/load/{conteneurId}';

  /**
   * Renvoie les 5 dernières demandes de transport (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurLoadListDemandes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurLoadListDemandes$Response(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursService.ConteneurLoadListDemandesPath, 'post');
    if (params) {
      rb.path('conteneurId', params.conteneurId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie les 5 dernières demandes de transport (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurLoadListDemandes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurLoadListDemandes(params: {

    /**
     * Identifiant du conteneur
     */
    conteneurId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.conteneurLoadListDemandes$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

}
